import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import * as source from "sources/books/expenses";
import connect from "./container";
import List from "./list";
import Show from "./show";

function Expenses(props) {
    const { location, history } = props;

    useEffect(() => {
        return () => props.clearParams("expenses");
    }, []);

    const back = () => history.push(paths.finances);

    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    exact
                    path={paths.expenses}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Список расходов"
                            back={back}
                            nofilter
                            source={source}
                        />
                    )}
                />
                <Route
                    path={`${paths.expenses}/:id`}
                    render={(rest) => (
                        <Show {...rest} title="Расход" back={() => history.push(paths.expenses)} source={source} />
                    )}
                />
            </Switch>
        </div>
    );
}

export default connect(Expenses);
